import type { IMaskFunction } from 'interfaces/IMask';
import { cleanCnpj, formatCnpj } from 'v2/helpers/cpfCnpj';

const cnpj: IMaskFunction = {
  apply: formatCnpj,
  clean: cleanCnpj
};

export default cnpj;
